import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  company: string = '';
  businessArea: string = '';

  constructor(private authService: AuthService) {}

  ngOnInit() {
    const token = this.authService.getToken();
    if (token) {
      const decodedToken = this.decodeToken(token);
      this.firstName = decodedToken.first_name;
      this.lastName = decodedToken.last_name;
      this.email = decodedToken.email;
      this.company = decodedToken.company;
      this.businessArea = decodedToken.business_area;
    }
  }

  private decodeToken(token: string): any {
    const payloadBase64 = token.split('.')[1];
    const payloadJson = decodeURIComponent(atob(payloadBase64).split('').map(c => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(payloadJson);
  }
}